module.exports = __webpack_public_path__ + "img/12m1.4eec54d4.jpg";